import React from 'react';
import View from 'components/main/pages/home/views/View';

import SubNav from 'components/main/items/SubNav';
import ProjectDetail from './subviews/ProjectDetail';
import SubmittedCards from './subviews/SubmittedCards';
import StudentProjects from './subviews/StudentProjects';
import ProjectFeatured from './subviews/ProjectFeatured';
import ProjectRanking from './subviews/ProjectRanking';
import ProjectDeleted from './subviews/ProjectDeleted';
import ProjectManagement from './subviews/ProjectManagement';

import StudentGroup from './subviews/group/student/StudentGroup';
import TeacherGroup from './subviews/group/teacher/TeacherGroup';

class Project extends View {

  componentDidMount(){
    this.init(this.props);
    const subView = this.store.content.subView;
    const user = this.store.user;
    if(!subView.includes('project')){
      this.actions.content.setSubView(
        (this.inSchool || this.store.projects.viewingProject.mlanghku)? 'projectFeatured':
        subView.includes('student')? 'projectGroup':
        user.type === 'student'? 'projectDetail': 'projectSubmitted');
    }
    this.getStudentProjects(this.props);
  }

  getStudentProjects(props){

    const viewingProject = this.store.projects.viewingProject;

    if(viewingProject.mlanghku && !viewingProject.fetched){
      this.actions.mlanghku.fetchStudentProjects(viewingProject);
      return;
    }
  
    const studentProjectsToGet = [];
    const studentProjectsToShow = viewingProject.studentProjects;

    for(var i=0;i<studentProjectsToShow.length;i++){
        if(this.func.getById.studentProject(studentProjectsToShow[i], this.store) === null){
        studentProjectsToGet.splice(0,0, studentProjectsToShow[i]);
      }
    }
  
    if(studentProjectsToGet.length > 0){
      this.actions.studentProjects.getStudentProjects(studentProjectsToGet);
    }
  }

  subView(subView, animatedStyle){
    const app = {...this.app, ...{ animatedStyle: animatedStyle}}
    var type = this.store.user.type;
    if(type === 'developer'){
      if(this.store.content.view === 'project'){
        type = 'teacher';
      }
    }

    switch (subView) {
      case 'projectDetail':
        return <ProjectDetail app={this.app}/>
      case 'projectSubmitted':
        return(
          type === 'student'? <SubmittedCards app={app}/>:
          type === 'teacher'? <StudentProjects app={app}/>:
          null
        )
      case 'projectRanking':
        return <ProjectRanking app={app}/>
      case 'projectFeatured':
        return <ProjectFeatured app={app}/>
      case 'projectGroup':
      return(
        type === 'student'? <StudentGroup app={app}/>:
        type === 'teacher'? <TeacherGroup app={app}/>:
        null
      )
      case 'projectDeleted':
        return <ProjectDeleted app={app}/>;
      case 'projectManagement':
        return <ProjectManagement app={app}/>;
      default:
        return null;
    }
  }

  projectSubNav(){
    const options = [
      {
        tag:['Featured','精選卡片','精选卡片'],
        subView: 'projectFeatured'
      },
      {
        tag:['Ranking','排行榜','排行榜'],
        subView: 'projectRanking'
      },
      {
        tag:['Detail','詳細資訊','详细资讯'],
        subView: 'projectDetail'
      }
    ];
    if(!this.store.projects.viewingProject.mlanghku){
      options.splice(1,0,
      {
        tag:['Group','小組','小组'],
        subView: 'projectGroup'
      });
    }
    if(this.store.projects.viewingProject.mlanghku){
      options.splice(1,1);
    }
    if((!this.inSchool && !this.store.projects.viewingProject.mlanghku) || this.store.user.type === 'developer'){
      options.splice(0,0,
      {
        tag:['Submitted','提交','提交'],
        subView: 'projectSubmitted',
      });
    }
    if(!this.inSchool && !this.store.projects.viewingProject.mlanghku && this.store.user.type === 'student'){
      options.splice(1,0,
      {
        tag:['deleted','已刪除','已刪除'],
        subView: 'projectDeleted',
      });
    }
    if(!this.inSchool && !this.store.projects.viewingProject.mlanghku && this.store.user.type === 'teacher'){
      options.splice(options.length,0,
      {
        tag:['Management','管理','管理'],
        subView: 'projectManagement',
      });
    }
    return <SubNav app={this.app} options={options} />
  }

  render(){
    this.init(this.props);
    const project = this.store.projects.viewingProject;

    const deadView = this.state.deadView;
    const view = this.state.view;

    var title = project.title;
    if(title.length > 44){ title = title.substr(0, 44) + '...'; }
    
    return(
      <div style={this.viewStyle()}>
        {this.tabBar([title, title, title])}
        {this.projectSubNav()}
        {this.sep()}
        {this.animatedSubView(this.subView.bind(this), deadView? deadView: view, deadView? false: true)}
      </div>
    )
  }
}

export default Project;
